import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.enableAccountStorageEvents();

export default msalInstance;
